var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavMissionsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68213 9.84482H8.31682V16.8265H10.8557V9.84482H11.4904V7.94073H7.68213V9.84482Z",
    fill: "#FBE0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8374 7.94073H14.0292V9.84482H14.6639V16.8265H17.2027V9.84482H17.8374V7.94073Z",
    fill: "#FBE0D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33521 9.84482H1.9699V16.8265H4.50873V9.84482H5.14343V7.94073H1.33521V9.84482Z",
    fill: "#FBE0D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1547 17.4612V15.5571H1.01782V17.4612H0.224487V20H18.9481V17.4612H18.1547Z",
    fill: "#FF6A14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.06476L9.5863 0L19.1726 8.06476H0Z",
    fill: "#FF6A14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5863 7.94073V16.8265H10.8557V9.84482H11.4904V7.94073H9.5863Z",
    fill: "#FBE0D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5863 0V8.06476H19.1726L9.5863 0Z",
    fill: "#FF6A14"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1547 17.4612V15.5571H9.5863V20H18.9481V17.4612H18.1547Z",
    fill: "#FF6A14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMissionsSelected);
export default __webpack_public_path__ + "static/media/nav_missions_selected.87a865a60439d5ba405170c32dfeaa6f.svg";
export { ForwardRef as ReactComponent };